import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
} from "date-fns";
import { NoarLocaliseApiService } from "./NoarLocaliseApiService";
import { Order } from "app/pages/admin/components/Table";

export const stableSort = <T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number,
): T[] => {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
};

export const getComparator = <Key extends keyof any>(
  order: Order,
  orderBy: Key,
): ((a: any, b: any) => number) =>
  order === "desc"
    ? (objectAscending, objectDescending) =>
        descendingComparator(objectAscending, objectDescending, orderBy)
    : (objectAscending, objectDescending) =>
        -descendingComparator(objectAscending, objectDescending, orderBy);

//acaba a função

export const descendingComparator = <T>(
  objectAscending: T,
  objectDescending: T,
  orderBy: keyof T,
) => {
  const aValue = getNestedValue(objectAscending, orderBy as string);
  const bValue = getNestedValue(objectDescending, orderBy as string);

  if (bValue < aValue) {
    return -1;
  }
  if (bValue > aValue) {
    return 1;
  }
  return 0;
};

export const getNestedValue = (object: any, value: string) => {
  return value
    .split(".")
    .reduce((objectSplit, index) => objectSplit?.[index], object);
};

export const removeAccents = (texto: string): string => {
  const mapaAcentos: Record<string, string> = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ú: "u",
    ã: "a",
    õ: "o",
    â: "a",
    ê: "e",
    î: "i",
    ô: "o",
    û: "u",
    à: "a",
    è: "e",
    ì: "i",
    ò: "o",
    ù: "u",
    ä: "a",
    ë: "e",
    ï: "i",
    ö: "o",
    ü: "u",
  };

  return texto
    .replace(
      /[áéíóúãõâêîôûàèìòùäëïöü]/g,
      (letra: string) => mapaAcentos[letra] || letra,
    )
    .replace(/[^\w\s]/gi, "")
    .toLowerCase();
};

export const replaceSpaceWithCharacter = (text: string, character: string) => {
  return text.replace(/ /g, character);
};

export const urlToFile = async (
  url: string,
  fileName: string,
): Promise<File> => {
  try {
    const response = await fetch(url);

    if (!response.ok)
      throw new Error(`Erro ao buscar imagem: ${response.statusText}`);

    const blob = await response.blob();
    const contentType =
      response.headers.get("content-type") || "application/octet-stream";

    return new File([blob], fileName, { type: contentType });
  } catch (error) {
    console.error("Erro ao converter URL para File:", error);
    throw error;
  }
};

export const fetchTempUri = async (
  mediaUri: string,
  api: NoarLocaliseApiService,
) => {
  try {
    const expiryDate = generateDate();

    const reqBase = {
      method: "GET",
      url: `/azure-blob/generate-temp-uri`,
    };

    const response = await api.makeHttpRequest({
      ...reqBase,
      params: { filePath: mediaUri, expirationTime: expiryDate },
    });

    return response.uri;
  } catch (error) {
    console.error("Failed to fetch temp URI:", error);
  }
};

export const generateDate = (daysAhead = 15): string => {
  const date = new Date();
  date.setDate(date.getDate() + daysAhead);
  return date.toISOString().split("T")[0];
};

export type FileType = "image" | "media" | "unknown";

export const getFileType = (url: string): FileType => {
  if (!url) return "unknown";

  const path = url.split("?")[0];
  const extension = path
    .split(".")
    .pop()
    ?.toLowerCase();

  if (!extension) return "unknown";

  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg"];
  const mediaExtensions = ["mp4", "mp3", "wav", "avi", "mov", "wmv"];

  if (imageExtensions.includes(extension)) return "image";
  if (mediaExtensions.includes(extension)) return "media";

  return "unknown";
};

export const calculateTime = (init: any, end: any) => {
  const inicio: any = new Date(init);
  const fim: any = new Date(end);
  const diferenca = new Date(fim - inicio);
  let resultado = diferenca.getUTCMinutes() + "m ";
  resultado += diferenca.getUTCSeconds() + "s ";
  return resultado;
};

export function calculateTimeDifference(
  startDate: Date,
  endDate: Date,
): string {
  const days = differenceInDays(endDate, startDate);
  const hours = differenceInHours(endDate, startDate) % 24;
  const minutes = differenceInMinutes(endDate, startDate) % 60;
  const seconds = differenceInSeconds(endDate, startDate) % 60;

  const formattedTimeDifference = [
    days > 0 ? `${days}d` : "",
    hours > 0 ? `${hours}h` : "",
    minutes > 0 ? `${minutes}m` : "",
    seconds > 0 ? `${seconds}s` : "",
  ]
    .filter(part => part !== "")
    .join(" ");

  return formattedTimeDifference;
}

export const imprimirElement = (divRef: React.RefObject<HTMLDivElement>) => {
  const conteudo = divRef.current;
  if (!conteudo) return;

  const janela = window.open("", "", "width=800,height=600");
  if (!janela) return;

  const html = `
    <html>
      <head>
        <title>PRINT PDF</title>
        <style>
          @media print {
            @page {
              margin: 0; 
            }
            body {
              margin: 0;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

           
            header, footer {
              display: none !important;
            }

          
            .nao-imprimir {
              display: none !important;
            }
          }

          body {
            font-family: Arial, sans-serif;
            padding: 40px;
          }
        </style>
      </head>
      <body>
        ${conteudo.innerHTML}
      </body>
    </html>
  `;

  janela.document.write(html);
  janela.document.close();

  
  janela.onload = () => {
    janela.focus();
    janela.print();
    janela.close();
  };
};
